// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Whether an outbound command addresses one car or the group.
 */
export enum CommandAddress {
  Unspecified = 0,
  Car = 1,
  Group = 2,
}
